import React from "react";
import {connect, useDispatch} from "react-redux";

import {p1} from "./pl_commons";

import {send_ac_cmd, send_edit_cmd} from "../../etc/cmd";

import Sw from "./sw";
import Sg from "./sg";
import Tk from "./tk";
import Bk from "./bk";

import Fb from "./fb";
import Tt from "./tt";
import Sb from './sb';
import {selectItem, signalClick} from "../../../data/actions";
import {useDrag, useDrop} from "react-dnd";

const NPlanitem = ({data, acc, bm, root, sgxClick, lcs, bidib}) => {

    const editmode = root.editmode
    const acceptors = [(data.type === 'sg' || data.type === 'bk') ? 'lc' : '', 'bm_port', 'acc_port']

    const [{isDragging }, drag] = useDrag(() => ({
        type: 'planitem',
        item: {
            id: data.id,
            type: data.type,
        },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult()

            if (item && dropResult) {
                if (dropResult.type === "empty") {
                    let target = {}
                    target.id = data.id
                    target.x = dropResult.x
                    target.y = dropResult.y
                    target.module = dropResult.module

                    send_edit_cmd(target)
                }
                if( dropResult.typename === "wastebin") {
                    console.log("DELETE %s", data.id)
                    let target = {}
                    target.id = data.id
                    target.deleted = true

                    send_edit_cmd(target)
                }
            }
        },
        canDrag: function(props, monitor) {
            return editmode
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        })
    }))

    const [{canDrop }, drop] = useDrop(() => ({
        // The type (or types) to accept - strings or symbols
        accept: acceptors,
        drop: () => ({
            id: `${data.id}`,
            type: `${data.type}`,
        }),
        /*canDrop: function(item, monitor) {
            return data.type === 'sw'
        },*/
        // Props to collect
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        })
    }))

    let style = {
        border: isDragging && canDrop ? '1px solid green' : null,
        //opacity: (isDragging && canDrop) ? 0.2 : 1.0,

        //opacity: (canDrop && isOver) ? 1.0 : 0.3,
    }


    const dispatch = useDispatch()

    function onContext(e) {
        e.preventDefault()
        dispatch(selectItem(data))
    }

    function handleClick(e) {
        if (root.editmode) {
            onContext(e);
        } else {
            if (data.type === 'sw') {
                let sendstate = data.accessorystate === "1" ? 0 : 1
                const cc = {
                    id: data.id,
                    port: parseInt(data.port) || 0xFF,
                    wanted: sendstate,
                }
                send_ac_cmd(cc);
            }
        }
    }

    // Signal click
    function sgClick(val) {
        dispatch(signalClick({sg: val}))
    }

    function attachRef(el) {
        drag(el)
        drop(el)
    }

    return (
        <div>
            {data.deleted !== true?
            <div onClick={handleClick} onContextMenu={onContext}
                 title={data.id + ' : ' + data.addr + ' : ' + data.port}
                 ref={attachRef}
                 style={{
                     top: data.y !== undefined ? parseInt(data.y) * p1 : 0,
                     left: data.x !== undefined ? parseInt(data.x) * p1 : 0,
                     width: p1,
                     height: p1,
                     margin: 0,
                     padding: 0,
                     position: 'absolute',
                     userSelect: 'none',
                     ...style,
                 }}
            >
                {data.type === 'tk' && <Tk item={data}/>}
                {data.type === 'sw' && <Sw item={data} bidib={bidib}/>}
                {data.type === 'sg' && <Sg item={data} startsignal={root.startsignal} onClick={sgClick} lcs={lcs}/>}
                {data.type === 'bk' && <Bk item={data}/>}
                {data.type === 'fb' && <Fb item={data} bidib={bidib}/>}
                {data.type === 'tt' && <Tt item={data} lcs={lcs}/>}
                {data.type === 'sb' && <Sb item={data} lcs={lcs}/>}

            </div>:null}
        </div>
    )
}

function mapStateToProps(state, other) {
    return {root: state.root, bidib: state.bidib.data.node}
}

export default connect(mapStateToProps)(NPlanitem)
